import { getCookie, setCookie } from '@lemonade-hq/cdk';
export { getCookie } from '@lemonade-hq/cdk';

var SESSION_COOKIE = "_lmnd_session_cookie";
var Cookie;
(function(Cookie) {
    Cookie["UUID"] = "_lmnd_uuid_2021";
    Cookie["EnableCookie"] = "_lmnd_enable_cookies";
    Cookie["CookieBannerAccepted"] = "_lmnd_cookie_banner_accepted";
    Cookie["UserId"] = "_cioid";
    Cookie["CookieTypesEnabled"] = "_lmnd_cookie_types_enabled";
    Cookie["Geography"] = "_lmnd_geography";
    Cookie["UTMs"] = "_lmnd_utm";
    Cookie["Region"] = "region";
})(Cookie || (Cookie = {}));
function decodeBase64Cookie(cookie) {
    var remainder = cookie.length % 4;
    var padding = 4 - remainder;
    var paddedB64 = cookie + "=".repeat(padding);
    return window.atob(paddedB64);
}
function encodeBase64Cookie(cookie) {
    return window.btoa(cookie).replaceAll("=", "");
}
function getJSONCookie(name) {
    var cookie = getCookie(name);
    if (cookie == null) return {};
    try {
        var decodedCookie = decodeBase64Cookie(cookie);
        return JSON.parse(decodedCookie);
    } catch (e) {
        return {};
    }
}
function setJSONCookie(name, value, options) {
    var encodedCookie = encodeBase64Cookie(JSON.stringify(value));
    setCookie(name, encodedCookie, options);
}

export { Cookie, SESSION_COOKIE, decodeBase64Cookie, encodeBase64Cookie, getJSONCookie, setJSONCookie };
